import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { generateFilterStateKey } from '@atlassian/notification-common';
import { LoadingState } from '@atlassian/notification-common/types';
export var DEFAULT_FILTER_STATE = {
  fetchState: LoadingState.INITIAL,
  error: undefined,
  fetchingDisabled: false,
  continuationToken: undefined,
  lastNotificationId: undefined
};
export var getFilterStateOrDefaultByKey = function getFilterStateOrDefaultByKey(state, filterStateKey) {
  return state[filterStateKey] || _objectSpread({}, DEFAULT_FILTER_STATE);
};
export var getFilterStateIfNew = function getFilterStateIfNew(filters, filterStates) {
  var filterStateKey = generateFilterStateKey(filters);
  if (filterStateKey in filterStates) {
    return undefined;
  } else {
    return {
      filterStates: _objectSpread(_objectSpread({}, filterStates), {}, _defineProperty({}, filterStateKey, _objectSpread({}, DEFAULT_FILTER_STATE)))
    };
  }
};